/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useMutation, useQuery } from '@tanstack/vue-query'
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query'

import { computed, unref } from 'vue'
import type { MaybeRef } from 'vue'

import type {
  AnalyzerBaseRequest,
  AnalyzerWithResponseFieldsRequest,
  CorrectnessStatsByPlayerAgressionPreflopResponse,
  CorrectnessStatsByPlayerPositionResponse,
  CorrectnessStatsByPotTypeResponse,
  CorrectnessStatsBySituationStreetResponse,
  CorrectnessStatsGeneralResponse,
  ErrorResponse,
  GetHandLinksParams,
  GtoScoreTrendResponse,
  HandFilterSchema,
  HandResponse,
  HandStatisticsGeneralResponse,
  HandsDeleteRequest,
  HandsRequest,
  HandsResponse,
  HandsUpdateRequest,
  LinksResponse,
} from '../models'

import bulkUpdateHandsMutator from '../../../client'
import bulkDeleteHandsMutator from '../../../client'
import bulkDeleteHandsByFiltersMutator from '../../../client'
import getHandMutator from '../../../client'
import getHandLinksMutator from '../../../client'
import handsMutator from '../../../client'
import handStatisticsReportTableMutator from '../../../client'
import gtoScoreTrendMutator from '../../../client'
import correctnessGeneralMutator from '../../../client'
import correctnessBySituationStreetMutator from '../../../client'
import correctnessByPotTypeMutator from '../../../client'
import correctnessByPlayerPositionMutator from '../../../client'
import correctnessByPlayerAggressionPreflopMutator from '../../../client'

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

/**
 * @summary Bulk Update Hands
 */
export const bulkUpdateHands = (
  handsUpdateRequest: MaybeRef<HandsUpdateRequest>,
  signal?: AbortSignal,
) => {
  handsUpdateRequest = unref(handsUpdateRequest)

  return bulkUpdateHandsMutator<void>({
    url: `/v4/hand-history/hands/bulk-update/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: handsUpdateRequest,
    signal,
  })
}

export const getBulkUpdateHandsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateHands>>,
    TError,
    { data: HandsUpdateRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateHands>>,
  TError,
  { data: HandsUpdateRequest },
  TContext
> => {
  const mutationKey = ['bulkUpdateHands']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateHands>>,
    { data: HandsUpdateRequest }
  > = props => {
    const { data } = props ?? {}

    return bulkUpdateHands(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BulkUpdateHandsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateHands>>>
export type BulkUpdateHandsMutationBody = HandsUpdateRequest
export type BulkUpdateHandsMutationError = ErrorResponse

/**
 * @summary Bulk Update Hands
 */
export const useBulkUpdateHands = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateHands>>,
    TError,
    { data: HandsUpdateRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof bulkUpdateHands>>,
  TError,
  { data: HandsUpdateRequest },
  TContext
> => {
  const mutationOptions = getBulkUpdateHandsMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Delete hands when using hands_ids
 * @summary Bulk Delete Hands
 */
export const bulkDeleteHands = (
  handsDeleteRequest: MaybeRef<HandsDeleteRequest>,
  signal?: AbortSignal,
) => {
  handsDeleteRequest = unref(handsDeleteRequest)

  return bulkDeleteHandsMutator<void>({
    url: `/v4/hand-history/hands/bulk-delete/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: handsDeleteRequest,
    signal,
  })
}

export const getBulkDeleteHandsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteHands>>,
    TError,
    { data: HandsDeleteRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteHands>>,
  TError,
  { data: HandsDeleteRequest },
  TContext
> => {
  const mutationKey = ['bulkDeleteHands']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteHands>>,
    { data: HandsDeleteRequest }
  > = props => {
    const { data } = props ?? {}

    return bulkDeleteHands(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BulkDeleteHandsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteHands>>>
export type BulkDeleteHandsMutationBody = HandsDeleteRequest
export type BulkDeleteHandsMutationError = ErrorResponse

/**
 * @summary Bulk Delete Hands
 */
export const useBulkDeleteHands = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteHands>>,
    TError,
    { data: HandsDeleteRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof bulkDeleteHands>>,
  TError,
  { data: HandsDeleteRequest },
  TContext
> => {
  const mutationOptions = getBulkDeleteHandsMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Delete hands in bulk when using filters other than hand_id (can include hand_id__in)
 * @summary Bulk Delete Hands By Filters
 */
export const bulkDeleteHandsByFilters = (
  handFilterSchema: MaybeRef<HandFilterSchema>,
  signal?: AbortSignal,
) => {
  handFilterSchema = unref(handFilterSchema)

  return bulkDeleteHandsByFiltersMutator<void>({
    url: `/v4/hand-history/hands/bulk-delete-by-filters/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: handFilterSchema,
    signal,
  })
}

export const getBulkDeleteHandsByFiltersMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteHandsByFilters>>,
    TError,
    { data: HandFilterSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteHandsByFilters>>,
  TError,
  { data: HandFilterSchema },
  TContext
> => {
  const mutationKey = ['bulkDeleteHandsByFilters']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteHandsByFilters>>,
    { data: HandFilterSchema }
  > = props => {
    const { data } = props ?? {}

    return bulkDeleteHandsByFilters(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type BulkDeleteHandsByFiltersMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteHandsByFilters>>
>
export type BulkDeleteHandsByFiltersMutationBody = HandFilterSchema
export type BulkDeleteHandsByFiltersMutationError = ErrorResponse

/**
 * @summary Bulk Delete Hands By Filters
 */
export const useBulkDeleteHandsByFilters = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteHandsByFilters>>,
    TError,
    { data: HandFilterSchema },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof bulkDeleteHandsByFilters>>,
  TError,
  { data: HandFilterSchema },
  TContext
> => {
  const mutationOptions = getBulkDeleteHandsByFiltersMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Get Hand
 */
export const getHand = (handId: MaybeRef<string>, signal?: AbortSignal) => {
  handId = unref(handId)

  return getHandMutator<HandResponse>({
    url: `/v4/hand-history/hands/${handId}/`,
    method: 'GET',
    signal,
  })
}

export const getGetHandQueryKey = (handId: MaybeRef<string>) => {
  return ['v4', 'hand-history', 'hands', handId] as const
}

export const getGetHandQueryOptions = <
  TData = Awaited<ReturnType<typeof getHand>>,
  TError = ErrorResponse,
>(
  handId: MaybeRef<string>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHand>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getGetHandQueryKey(handId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHand>>> = ({ signal }) =>
    getHand(handId, signal)

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(handId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getHand>>, TError, TData>
}

export type GetHandQueryResult = NonNullable<Awaited<ReturnType<typeof getHand>>>
export type GetHandQueryError = ErrorResponse

/**
 * @summary Get Hand
 */

export function useGetHand<TData = Awaited<ReturnType<typeof getHand>>, TError = ErrorResponse>(
  handId: MaybeRef<string>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHand>>, TError, TData>>
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHandQueryOptions(handId, options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>

  return query
}

/**
 * @summary Get Hand Links
 */
export const getHandLinks = (
  handId: MaybeRef<string>,
  params: MaybeRef<GetHandLinksParams>,
  signal?: AbortSignal,
) => {
  handId = unref(handId)
  params = unref(params)

  return getHandLinksMutator<LinksResponse>({
    url: `/v4/hand-history/hands/${handId}/links/`,
    method: 'GET',
    params: unref(params),
    signal,
  })
}

export const getGetHandLinksQueryKey = (
  handId: MaybeRef<string>,
  params: MaybeRef<GetHandLinksParams>,
) => {
  return ['v4', 'hand-history', 'hands', handId, 'links', ...(params ? [params] : [])] as const
}

export const getGetHandLinksQueryOptions = <
  TData = Awaited<ReturnType<typeof getHandLinks>>,
  TError = ErrorResponse,
>(
  handId: MaybeRef<string>,
  params: MaybeRef<GetHandLinksParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandLinks>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getGetHandLinksQueryKey(handId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandLinks>>> = ({ signal }) =>
    getHandLinks(handId, params, signal)

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(handId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getHandLinks>>, TError, TData>
}

export type GetHandLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getHandLinks>>>
export type GetHandLinksQueryError = ErrorResponse

/**
 * @summary Get Hand Links
 */

export function useGetHandLinks<
  TData = Awaited<ReturnType<typeof getHandLinks>>,
  TError = ErrorResponse,
>(
  handId: MaybeRef<string>,
  params: MaybeRef<GetHandLinksParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandLinks>>, TError, TData>>
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHandLinksQueryOptions(handId, params, options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>

  return query
}

/**
 * @summary Hands
 */
export const hands = (handsRequest: MaybeRef<HandsRequest>, signal?: AbortSignal) => {
  handsRequest = unref(handsRequest)

  return handsMutator<HandsResponse>({
    url: `/v4/hand-history/hands/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: handsRequest,
    signal,
  })
}

export const getHandsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hands>>,
    TError,
    { data: HandsRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof hands>>,
  TError,
  { data: HandsRequest },
  TContext
> => {
  const mutationKey = ['hands']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hands>>,
    { data: HandsRequest }
  > = props => {
    const { data } = props ?? {}

    return hands(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type HandsMutationResult = NonNullable<Awaited<ReturnType<typeof hands>>>
export type HandsMutationBody = HandsRequest
export type HandsMutationError = unknown

/**
 * @summary Hands
 */
export const useHands = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hands>>,
    TError,
    { data: HandsRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof hands>>,
  TError,
  { data: HandsRequest },
  TContext
> => {
  const mutationOptions = getHandsMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Hand Statistics Report Table
 */
export const handStatisticsReportTable = (
  analyzerWithResponseFieldsRequest: MaybeRef<AnalyzerWithResponseFieldsRequest>,
  signal?: AbortSignal,
) => {
  analyzerWithResponseFieldsRequest = unref(analyzerWithResponseFieldsRequest)

  return handStatisticsReportTableMutator<HandStatisticsGeneralResponse>({
    url: `/v4/hand-history/hand-statistics/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: analyzerWithResponseFieldsRequest,
    signal,
  })
}

export const getHandStatisticsReportTableMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handStatisticsReportTable>>,
    TError,
    { data: AnalyzerWithResponseFieldsRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof handStatisticsReportTable>>,
  TError,
  { data: AnalyzerWithResponseFieldsRequest },
  TContext
> => {
  const mutationKey = ['handStatisticsReportTable']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handStatisticsReportTable>>,
    { data: AnalyzerWithResponseFieldsRequest }
  > = props => {
    const { data } = props ?? {}

    return handStatisticsReportTable(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type HandStatisticsReportTableMutationResult = NonNullable<
  Awaited<ReturnType<typeof handStatisticsReportTable>>
>
export type HandStatisticsReportTableMutationBody = AnalyzerWithResponseFieldsRequest
export type HandStatisticsReportTableMutationError = unknown

/**
 * @summary Hand Statistics Report Table
 */
export const useHandStatisticsReportTable = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handStatisticsReportTable>>,
    TError,
    { data: AnalyzerWithResponseFieldsRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof handStatisticsReportTable>>,
  TError,
  { data: AnalyzerWithResponseFieldsRequest },
  TContext
> => {
  const mutationOptions = getHandStatisticsReportTableMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Gto Score Trend
 */
export const gtoScoreTrend = (
  analyzerBaseRequest: MaybeRef<AnalyzerBaseRequest>,
  signal?: AbortSignal,
) => {
  analyzerBaseRequest = unref(analyzerBaseRequest)

  return gtoScoreTrendMutator<GtoScoreTrendResponse>({
    url: `/v4/hand-history/gto-score-trend/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: analyzerBaseRequest,
    signal,
  })
}

export const getGtoScoreTrendMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gtoScoreTrend>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof gtoScoreTrend>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationKey = ['gtoScoreTrend']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gtoScoreTrend>>,
    { data: AnalyzerBaseRequest }
  > = props => {
    const { data } = props ?? {}

    return gtoScoreTrend(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type GtoScoreTrendMutationResult = NonNullable<Awaited<ReturnType<typeof gtoScoreTrend>>>
export type GtoScoreTrendMutationBody = AnalyzerBaseRequest
export type GtoScoreTrendMutationError = unknown

/**
 * @summary Gto Score Trend
 */
export const useGtoScoreTrend = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gtoScoreTrend>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof gtoScoreTrend>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationOptions = getGtoScoreTrendMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Correctness General
 */
export const correctnessGeneral = (
  analyzerBaseRequest: MaybeRef<AnalyzerBaseRequest>,
  signal?: AbortSignal,
) => {
  analyzerBaseRequest = unref(analyzerBaseRequest)

  return correctnessGeneralMutator<CorrectnessStatsGeneralResponse>({
    url: `/v4/hand-history/hand-correctness/score-breakdown/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: analyzerBaseRequest,
    signal,
  })
}

export const getCorrectnessGeneralMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessGeneral>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctnessGeneral>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationKey = ['correctnessGeneral']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctnessGeneral>>,
    { data: AnalyzerBaseRequest }
  > = props => {
    const { data } = props ?? {}

    return correctnessGeneral(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CorrectnessGeneralMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctnessGeneral>>
>
export type CorrectnessGeneralMutationBody = AnalyzerBaseRequest
export type CorrectnessGeneralMutationError = unknown

/**
 * @summary Correctness General
 */
export const useCorrectnessGeneral = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessGeneral>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof correctnessGeneral>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationOptions = getCorrectnessGeneralMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Correctness By Situation Street
 */
export const correctnessBySituationStreet = (
  analyzerBaseRequest: MaybeRef<AnalyzerBaseRequest>,
  signal?: AbortSignal,
) => {
  analyzerBaseRequest = unref(analyzerBaseRequest)

  return correctnessBySituationStreetMutator<CorrectnessStatsBySituationStreetResponse>({
    url: `/v4/hand-history/hand-correctness/street/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: analyzerBaseRequest,
    signal,
  })
}

export const getCorrectnessBySituationStreetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessBySituationStreet>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctnessBySituationStreet>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationKey = ['correctnessBySituationStreet']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctnessBySituationStreet>>,
    { data: AnalyzerBaseRequest }
  > = props => {
    const { data } = props ?? {}

    return correctnessBySituationStreet(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CorrectnessBySituationStreetMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctnessBySituationStreet>>
>
export type CorrectnessBySituationStreetMutationBody = AnalyzerBaseRequest
export type CorrectnessBySituationStreetMutationError = unknown

/**
 * @summary Correctness By Situation Street
 */
export const useCorrectnessBySituationStreet = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessBySituationStreet>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof correctnessBySituationStreet>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationOptions = getCorrectnessBySituationStreetMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Correctness By Pot Type
 */
export const correctnessByPotType = (
  analyzerBaseRequest: MaybeRef<AnalyzerBaseRequest>,
  signal?: AbortSignal,
) => {
  analyzerBaseRequest = unref(analyzerBaseRequest)

  return correctnessByPotTypeMutator<CorrectnessStatsByPotTypeResponse>({
    url: `/v4/hand-history/hand-correctness/preflop-action/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: analyzerBaseRequest,
    signal,
  })
}

export const getCorrectnessByPotTypeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessByPotType>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctnessByPotType>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationKey = ['correctnessByPotType']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctnessByPotType>>,
    { data: AnalyzerBaseRequest }
  > = props => {
    const { data } = props ?? {}

    return correctnessByPotType(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CorrectnessByPotTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctnessByPotType>>
>
export type CorrectnessByPotTypeMutationBody = AnalyzerBaseRequest
export type CorrectnessByPotTypeMutationError = unknown

/**
 * @summary Correctness By Pot Type
 */
export const useCorrectnessByPotType = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessByPotType>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof correctnessByPotType>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationOptions = getCorrectnessByPotTypeMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Correctness By Player Position
 */
export const correctnessByPlayerPosition = (
  analyzerBaseRequest: MaybeRef<AnalyzerBaseRequest>,
  signal?: AbortSignal,
) => {
  analyzerBaseRequest = unref(analyzerBaseRequest)

  return correctnessByPlayerPositionMutator<CorrectnessStatsByPlayerPositionResponse>({
    url: `/v4/hand-history/hand-correctness/position/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: analyzerBaseRequest,
    signal,
  })
}

export const getCorrectnessByPlayerPositionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessByPlayerPosition>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctnessByPlayerPosition>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationKey = ['correctnessByPlayerPosition']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctnessByPlayerPosition>>,
    { data: AnalyzerBaseRequest }
  > = props => {
    const { data } = props ?? {}

    return correctnessByPlayerPosition(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CorrectnessByPlayerPositionMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctnessByPlayerPosition>>
>
export type CorrectnessByPlayerPositionMutationBody = AnalyzerBaseRequest
export type CorrectnessByPlayerPositionMutationError = unknown

/**
 * @summary Correctness By Player Position
 */
export const useCorrectnessByPlayerPosition = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessByPlayerPosition>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof correctnessByPlayerPosition>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationOptions = getCorrectnessByPlayerPositionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Correctness By Player Aggression Preflop
 */
export const correctnessByPlayerAggressionPreflop = (
  analyzerBaseRequest: MaybeRef<AnalyzerBaseRequest>,
  signal?: AbortSignal,
) => {
  analyzerBaseRequest = unref(analyzerBaseRequest)

  return correctnessByPlayerAggressionPreflopMutator<CorrectnessStatsByPlayerAgressionPreflopResponse>(
    {
      url: `/v4/hand-history/hand-correctness/preflop-agression/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: analyzerBaseRequest,
      signal,
    },
  )
}

export const getCorrectnessByPlayerAggressionPreflopMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessByPlayerAggressionPreflop>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctnessByPlayerAggressionPreflop>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationKey = ['correctnessByPlayerAggressionPreflop']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctnessByPlayerAggressionPreflop>>,
    { data: AnalyzerBaseRequest }
  > = props => {
    const { data } = props ?? {}

    return correctnessByPlayerAggressionPreflop(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CorrectnessByPlayerAggressionPreflopMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctnessByPlayerAggressionPreflop>>
>
export type CorrectnessByPlayerAggressionPreflopMutationBody = AnalyzerBaseRequest
export type CorrectnessByPlayerAggressionPreflopMutationError = unknown

/**
 * @summary Correctness By Player Aggression Preflop
 */
export const useCorrectnessByPlayerAggressionPreflop = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctnessByPlayerAggressionPreflop>>,
    TError,
    { data: AnalyzerBaseRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof correctnessByPlayerAggressionPreflop>>,
  TError,
  { data: AnalyzerBaseRequest },
  TContext
> => {
  const mutationOptions = getCorrectnessByPlayerAggressionPreflopMutationOptions(options)

  return useMutation(mutationOptions)
}
